import React from 'react';
import { Modal, ModalHeader, Button } from 'reactstrap';
import { DeletePrinterPoint } from './DeletePrinterPoint';
import { FormPrinterPoint } from './FormPrinterPoint';
import { Dialog } from 'primereact/dialog';


export const ModalPrinterPoint = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones,
        saveCreate, saveUpdate, saveDelete, mSelectBranch, branches
    } = props;

    const labelButton = method === "create"
        ? "Crear nuevo punto de impresión"
        : method === "update"
            ? "Actualizar pinto de impresión"
            : "Confirmar";

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                {loading ? "Procesando..." : labelButton}
            </Button>

            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
        </div>
    );


    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            modal
            blockScroll
            footer={footer}
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-print f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}


        >

            {
                method === "create" ?
                    <FormPrinterPoint
                        button="Crear nuevo punto de impresión"
                        {...{ loading, name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones, mSelectBranch, branches, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormPrinterPoint
                            button="Actualizar punto de impresión"
                            {...{ loading, name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones, mSelectBranch, branches, methodAction: saveUpdate }}
                        />
                        : null
            }
        </Dialog>
    )
}
